(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-collection-filters"] && !Shopify.designMode) return;
  try {
    class CCollectionFiltersComponent extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('[data-filters-form]');
      this.closeButton = this.querySelector('[data-close-filters]');
      this.filterGroups = this.querySelectorAll('.c-filter-group');
      this.priceFilter = this.querySelector('[data-price-filter]');
      this.bindEvents();
      this.initPriceSlider();
      this.initToggleIcons();
    }

    bindEvents() {
      // Close button
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('filters:close', { bubbles: true }));
        });
      }

      // Form submission
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.applyFilters();
        });

        // Auto-submit on checkbox change (except collection filters)
        this.form.querySelectorAll('input[type="checkbox"]:not([name="collection_filter"])').forEach((input) => {
          input.addEventListener('change', () => {
            this.applyFilters();
          });
        });

        // Collection filter checkbox handling - navigate to filter URL
        this.form.querySelectorAll('input[name="collection_filter"]').forEach((input) => {
          input.addEventListener('change', (e) => {
            const checkbox = e.target;
            const filterUrl = checkbox.dataset.filterUrl;

            if (checkbox.checked && filterUrl) {
              // Navigate to the filter URL via AJAX
              document.dispatchEvent(
                new CustomEvent('filters:apply', {
                  bubbles: true,
                  detail: { url: filterUrl },
                })
              );
            } else {
              // If unchecked, clear the collection filter
              const baseUrl = window.location.pathname;
              const params = new URLSearchParams(window.location.search);
              params.delete('collection_filter');
              const newUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

              document.dispatchEvent(
                new CustomEvent('filters:apply', {
                  bubbles: true,
                  detail: { url: newUrl },
                })
              );
            }

            // Uncheck other collection filter checkboxes (single select behavior)
            if (checkbox.checked) {
              this.form.querySelectorAll('input[name="collection_filter"]').forEach((other) => {
                if (other !== checkbox) {
                  other.checked = false;
                }
              });
            }
          });
        });
      }

      // Toggle icons on details open/close
      this.filterGroups.forEach((group) => {
        group.addEventListener('toggle', () => {
          const toggle = group.querySelector('.c-filter-group__toggle');
          if (toggle) {
            toggle.textContent = group.open ? '-' : '+';
          }
        });
      });
    }

    initToggleIcons() {
      // Set initial toggle icons
      this.filterGroups.forEach((group) => {
        const toggle = group.querySelector('.c-filter-group__toggle');
        if (toggle) {
          toggle.textContent = group.open ? '-' : '+';
        }
      });
    }

    initPriceSlider() {
      if (!this.priceFilter) return;

      const minInput = this.priceFilter.querySelector('[data-price-min]');
      const maxInput = this.priceFilter.querySelector('[data-price-max]');
      const rangeEl = this.priceFilter.querySelector('[data-price-range]');
      const minDisplay = this.priceFilter.querySelector('[data-price-min-display]');
      const maxDisplay = this.priceFilter.querySelector('[data-price-max-display]');

      if (!minInput || !maxInput || !rangeEl) return;

      const updateSlider = () => {
        const min = parseFloat(minInput.min);
        const max = parseFloat(minInput.max);
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);

        // Calculate percentages
        const minPercent = ((minVal - min) / (max - min)) * 100;
        const maxPercent = ((maxVal - min) / (max - min)) * 100;

        // Update range bar position
        rangeEl.style.left = minPercent + '%';
        rangeEl.style.width = maxPercent - minPercent + '%';

        // Update display values (dollars)
        if (minDisplay) {
          minDisplay.textContent = '$' + Math.round(minVal);
        }
        if (maxDisplay) {
          maxDisplay.textContent = '$' + Math.round(maxVal);
        }
      };

      // Initial update
      updateSlider();

      // Debounce function for filter application
      let debounceTimer;
      const debounceApply = () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          this.applyFilters();
        }, 800);
      };

      // Min slider events
      minInput.addEventListener('input', () => {
        let minVal = parseFloat(minInput.value);
        let maxVal = parseFloat(maxInput.value);

        // Prevent min from exceeding max
        if (minVal >= maxVal) {
          minInput.value = maxVal - 1;
        }

        updateSlider();
      });

      minInput.addEventListener('change', debounceApply);

      // Max slider events
      maxInput.addEventListener('input', () => {
        let minVal = parseFloat(minInput.value);
        let maxVal = parseFloat(maxInput.value);

        // Prevent max from going below min
        if (maxVal <= minVal) {
          maxInput.value = minVal + 1;
        }

        updateSlider();
      });

      maxInput.addEventListener('change', debounceApply);
    }

    applyFilters() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams();

      // Preserve collection_filter from URL if it exists
      const currentParams = new URLSearchParams(window.location.search);
      const collectionFilter = currentParams.get('collection_filter');
      if (collectionFilter) {
        params.set('collection_filter', collectionFilter);
      }

      for (const [key, value] of formData.entries()) {
        // Skip collection_filter as it's handled separately via checkbox click
        if (key === 'collection_filter') continue;
        if (value) {
          params.append(key, value);
        }
      }

      const url = `${window.location.pathname}?${params.toString()}`;

      // Dispatch custom event for AJAX filtering instead of full page reload
      document.dispatchEvent(
        new CustomEvent('filters:apply', {
          bubbles: true,
          detail: { url },
        })
      );
    }

    reinitialize() {
      // Rebind events after AJAX content update
      this.form = this.querySelector('[data-filters-form]');
      this.closeButton = this.querySelector('[data-close-filters]');
      this.filterGroups = this.querySelectorAll('.c-filter-group');
      this.priceFilter = this.querySelector('[data-price-filter]');
      this.bindEvents();
      this.initPriceSlider();
      this.initToggleIcons();
    }
  }

  if (!customElements.get('c-collection-filters-component')) {
    customElements.define('c-collection-filters-component', CCollectionFiltersComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crawl-budget-optimization"] && !Shopify.designMode) return;
  try {
    // Preconnect to search engines para mejorar crawl speed
  if (document.head) {
    const preconnects = [
      'https://www.google.com',
      'https://www.googlebot.com',
      'https://search.google.com'
    ];
    
    preconnects.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  // Lazy load non-critical content para mejorar performance
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // JSON-LD optimization para mejor crawling
  function addStructuredData() {
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (!existingScript && window.meta && window.meta.page) {
      const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": window.location.href,
        "name": document.title,
        "publisher": {
          "@type": "Organization",
          "name": "{{ shop.name }}",
          "url": "{{ shop.url }}"
        }
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStructuredData);
  } else {
    addStructuredData();
  }
  } catch(e) { console.error(e); }
})();

})();
